// src/components/CommentSection.js

import React, {useEffect, useState} from 'react';
import './commentSection.scss';
import newRequest from "../../context/newRequest";


const CommentSection = (idTicket) => {
    const [comments, setComments] = useState([]);
    const [commentText, setCommentText] = useState('');
    const  id  = idTicket;
    useEffect(() => {
        fetchComments();
    }, []);

    const fetchComments = async () => {
        try {
            const res = await newRequest.get(`/comments/${id.ticketId}`);
            setComments(res.data.data);
        } catch (error) {
            console.error("Error fetching comments:", error);
        }
    };


    const handleCommentChange = (e) => {
        setCommentText(e.target.value);
    };

    const handleCommentSubmit = async () => {
        if (commentText.trim()) {
            const newComment = {
                content: commentText,
            };

            try {
                const response = await newRequest.post(`/comments/${id.ticketId}`, newComment, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                setComments([response.data.data, ...comments]);
                setCommentText('');
            } catch (error) {
                console.error("Error adding comment:", error);
            }
        }
    };


    return (
        <div className="comment-section">
            <h3>Comments</h3>
            <textarea
                id="comment-input"
                value={commentText}
                onChange={handleCommentChange}
                placeholder="Tulis komentar Anda di sini..."
            />
            <button id="submit-comment" onClick={handleCommentSubmit}>
                Kirim
            </button>

            <div className="comments-list">
                {comments.length === 0 && <p>Belum ada komentar.</p>}
                {comments.map(comment => (
                    <div key={comment.id} className="comment">
                        <p className="comment-author">{comment.user_id}</p>
                        <p className="comment-time">
                            {new Date(comment.created_at).toLocaleString('id-ID', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                            })}
                        </p>
                        <p
                            className="comment-content"
                            dangerouslySetInnerHTML={{
                                __html: comment.content.replace(/\n/g, "<br />"), // Ganti \n dengan <br />
                            }}
                        ></p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CommentSection;
